import { Button, Divider, Typography } from "@material-ui/core";
import ImageIcon from "@material-ui/icons/Image";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import clsx from "clsx";
import { FC, Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";

import { AlertTimelineConnector } from "@/common/components/SVG/Svg";
import { AlertTileContext } from "@/common/contexts/AlertTileContextType";
import { AlertType, TimestampCameraMedia } from "@/utilities/types/alert";

import useStyles from "./AlertFooter.Styles";


interface AlertFooterProps {
    alertType?: AlertType;
    locationTimezone?: string;
    alertMedia: TimestampCameraMedia[];
}

export const AlertFooter: FC<AlertFooterProps> = ({ alertType, locationTimezone, alertMedia }) => {
    const { t, i18n } = useTranslation("translation", { keyPrefix: "components.alerts.alertFooter" });
    const { currentAlertTimestamp, setCurrentAlertTimestamp } = useContext(AlertTileContext);
    const classes = useStyles();
    const dateString = alertMedia[0]?.timestamp;
    const alertDate = new Date(dateString);
    const dateFmt = new Intl.DateTimeFormat(i18n.language, {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: locationTimezone,
        timeZoneName: "short",
    });

    const timeFmt = new Intl.DateTimeFormat(i18n.language, { timeStyle: "short", timeZone: locationTimezone });

    const formattedAlertDate = dateFmt.format(alertDate);
    const tAlertType = t([`alertType.${alertType!}`, "alertTypeDefault"]);

    return (
        <div className={classes.footer} data-testid="alertFooter">
            <Typography className={classes.alertDetails}>
                {tAlertType}: {formattedAlertDate}
            </Typography>
            <Divider variant="middle" orientation="vertical" flexItem />
            <div className={classes.alertTimelineButtons}>
                {alertMedia.map((media, index) => {
                    return (
                        <Fragment key={media.timestamp}>
                            <Button
                                size="large"
                                className={clsx(
                                    classes.alertButtonFlex,
                                    currentAlertTimestamp === media.timestamp
                                        ? clsx(classes.alertClipSelectedButton, classes.alertClipButtonBackground)
                                        : classes.alertClipButton,
                                )}
                                startIcon={index === 0 ? <PlayArrowIcon /> : <ImageIcon />}
                                variant="outlined"
                                onClick={() => {
                                    setCurrentAlertTimestamp(media.timestamp);
                                }}
                            >
                                {timeFmt.format(new Date(media.timestamp))}
                            </Button>
                            {index + 1 !== alertMedia.length && (
                                <div className={classes.alertTimelineConnector}>
                                    <AlertTimelineConnector />
                                </div>
                            )}
                        </Fragment>
                    );
                })}
            </div>

            <Divider variant="middle" orientation="vertical" flexItem />
        </div>
    );
};
